export class RoadUnit{
  constructor(start, end){
  this.stakeval = start.stakeval;
  this.start = start;
  this.end = end;
  //当station的值发生变化的时候，需要联动数据
  this.start.asStartRoadUnit = this;
  this.end.asEndRoadUnit = this;
  this.criticalPoints = new Array();  
  }
} 
  


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/RoadUnit.js